// English placeholders per SDL localization process (agency translates weekly).
export default function getResource(label, vars = []) {
    const resources = {
        rewardBundlingTitle: 'Recevez trois récompenses de 100 points pour seulement 250 points.',
        rewardBundlingDescription: 'Ce privilège sera appliqué automatiquement lors du paiement, un ensemble par commande, offert uniquement pour les commandes expédiées.',
        rewardBundlingTermsApply: 'Des modalités s’appliquent',
        rewardBundlingPromoApplied: 'Promotion appliquée 🎉',
        rewardBundlingProgressAccessibility: 'Progression du cumul des récompenses'
    };

    return resources[label];
}
